exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customer-presentation dt{font-weight:700}.customer-presentation dd{padding-left:1em;margin-bottom:1em}.customer-presentation dd i{color:#7b7b7b}", ""]);

// exports
